import { Injectable } from "@angular/core";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { AuthenticationService } from "../../_services/user/authentication/authentication.service";

@Injectable({ providedIn: "root" })
export class AuthGuard  {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authenticationService.currentUser;
    if (currentUser) {
      // TODO: Based on user's role, and what they're able to access
      // redirect them to various locations
      if (!this.authenticationService.loggedInUserIsNotViewer() && !this.authenticationService.currentUser.isSupport) {
        this.router.navigate(["/gae-staff-report"]);
        alert(
          "You cannot view that page as a 'Viewer'. Please contact the GAE for your Geographic Area to obtain an appropriate user role to continue"
        );
      }
      return this.authenticationService.loggedInUserIsNotViewer() || this.authenticationService.currentUser.isSupport;
    } else {
      this.router.navigate(["/"], { queryParams: { returnUrl: state.url } });
      alert("You must be logged in to view that page");
    }

    // not logged in so redirect to login page with the return url
    // this.router.navigate(["/login"], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
